import React from 'react';
import { Box, Divider } from 'vindi-ds-components';
import { PrFile } from 'vindi-ds-icons/pr';
import styles from '../styles';

import ReportCard from './reportCard';

function AdminReport({ isMobile }) {
  return (
    <>
      {!isMobile && <Divider spacing='xs' />}

      <Box css={!isMobile && styles.root}>
        <ReportCard
          icon={<PrFile />}
          isMobile={isMobile}
          name='Documentos'
          links={[{
            route: 'reports/documents',
          }]}
        />
      </Box>
    </>
  );
}

export default AdminReport;
